import { render, staticRenderFns } from "./CallBadge.vue?vue&type=template&id=50de56a3"
import script from "./CallBadge.vue?vue&type=script&lang=js"
export * from "./CallBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports